import { NgModule } from '@angular/core';

import { RtUIModule } from '@recruitee/user-interface';

import { BlockPasswordChangeDialogComponent } from '../dialogs/block-password-change-dialog/block-password-change-dialog.component';

@NgModule({
  imports: [RtUIModule],
  declarations: [BlockPasswordChangeDialogComponent],
  exports: [BlockPasswordChangeDialogComponent],
})
export class RtBlockPasswordChangeDialogSharedModule {}

export { BlockPasswordChangeDialogComponent };
